import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFlow';
/** Renders an SVG icon. */
const SvgFlow = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M12 6V4h8v2zm2.414 9L16 13.414 17.586 15 16 16.586zM6 22h4v4H6zM22 4a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3v3.586L12.586 14H10a3 3 0 0 0-3 3v3H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H9v-3a1 1 0 0 1 1-1h2.586l2.707 2.707.076.068a1 1 0 0 0 1.338-.068L19.414 16H22a1 1 0 0 1 1 1v4a1 1 0 1 0 2 0v-4a3 3 0 0 0-3-3h-2.586L17 11.586V8h3a2 2 0 0 0 2-2z"
      />
      <path fill="currentColor" d="M26 24a2 2 0 1 0-2 2v2a4 4 0 1 1 0-8 4 4 0 0 1 0 8v-2a2 2 0 0 0 2-2" />
    </svg>
  );
};
SvgFlow.displayName = displayName;
export default SvgFlow;
